import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { Observable, forkJoin, of } from "rxjs";
import { mergeMap, take } from "rxjs/operators";

import { OrderModel } from "../models/order.model";
import { DataService } from "../services/data/data.service";
import { OrderService } from "../services/order/order.service";

@Injectable({
  providedIn: "root"
})
export class ProducerOrderResolverService implements Resolve<OrderModel> {
  constructor(private dataService: DataService, private orderService: OrderService,) {}

  resolve(route: ActivatedRouteSnapshot,  state: RouterStateSnapshot): Observable<OrderModel> | Observable<never> {
    const id = route.paramMap.get("orderId");
    const profileId = route.paramMap.get("profileId");
    const saleId = route.paramMap.get("tourneeId");
    const join = forkJoin({
      item: this.dataService.getProducerOrder(id, profileId, saleId).pipe(take(1)),
      products: this.dataService.getProducerOrderProductsOrdered(profileId, saleId, id).pipe(take(1)),
      details:this.dataService.getTourneeDetailsProducer(saleId, profileId).pipe(take(1)),
      status: this.dataService.getTourneeStatusProducer(saleId, profileId).pipe(take(1)),
    });
    return join.pipe(
      mergeMap(result => {
        console.log(result);
        const item:OrderModel = result.item;
        item.tournee = result.details;
        item.tournee.producer = {key:profileId};
        item.tournee.status = <string>result.status;
        if(result.products && Object.keys(result.products).length>0){
          if(!item.products){
            item.products = {
              references:{}
            }
          }
          item.products.references = result.products;
        }
        this.orderService.convertOrderToDatePlaceSystem(item);
        return of(item);
    }))
  }
}
